var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../configuration/event-messages.constants";
var ButtonMultiSelector = /** @class */ (function () {
    function ButtonMultiSelector(element, eventAggrigator) {
        var _this = this;
        this.element = element;
        this.eventAggrigator = eventAggrigator;
        this.ripple = true;
        this.dropdownDirection = 'auto';
        this.indexFocusedLi = 0;
        this.currentContext = this;
        this.closePopup = function () {
            _this.isDropdownOpen = false;
        };
    }
    ButtonMultiSelector.prototype.detached = function () {
        if (this.subscriptionToDocumentClickEvent) {
            this.subscriptionToDocumentClickEvent.dispose();
        }
    };
    ButtonMultiSelector.prototype.itemSourceChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue === oldValue) {
            return;
        }
        this.itemSourceAsEnumerable = Enumerable.from(this.itemSource);
        if (newValue && this.selectedValue) {
            var selectedValueStringified_1 = JSON.stringify(this.selectedValue);
            var condition = function (x) { return JSON.stringify(_this.getValue(x)) == selectedValueStringified_1 || _this.getValue(x) == _this.selectedValue; };
            this.selectedItem = this.itemSourceAsEnumerable.firstOrDefault(condition);
        }
        if (this.setDefault && !this.selectedItem) {
            this.select(this.itemSourceAsEnumerable.firstOrDefault());
        }
    };
    ButtonMultiSelector.prototype.setDefaultChanged = function (newValue, oldValue) {
        if (this.setDefault && this.itemSource && !this.selectedItem && !this.selectedValue) {
            this.select(Enumerable.from(this.itemSource).firstOrDefault());
        }
    };
    ButtonMultiSelector.prototype.selectedValueChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue === oldValue) {
            return;
        }
        if (this.itemSource) {
            this.selectedItem = Enumerable.from(this.itemSource)
                .firstOrDefault(function (x) { return _this.getValue(x) == newValue; });
            this.indexFocusedLi = this.itemSource.indexOf(this.selectedItem) % this.itemSource.length;
        }
    };
    ButtonMultiSelector.prototype.selectedItemChanged = function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.selectedValue = this.getValue(newValue);
    };
    ButtonMultiSelector.prototype.focusTextBox = function (selectAlltext) {
        if (selectAlltext === void 0) { selectAlltext = false; }
        var input = this.input;
        if (input) {
            setTimeout(function () {
                input.focus();
                if (selectAlltext) {
                    input.select();
                }
            });
        }
    };
    ButtonMultiSelector.prototype.stopPropagation = function (e) {
        e.stopPropagation();
    };
    ButtonMultiSelector.prototype.getDisplayName = function (item) {
        return this.displayMemberPath && item ? item[this.displayMemberPath] : item;
    };
    ButtonMultiSelector.prototype.select = function (item) {
        if (this.loading || this.disabled)
            return;
        if (item) {
            this.selectedItem = item;
            this.selectedValue = this.getValue(item);
            this.isDropdownOpen = false;
            this.onSelect();
        }
    };
    ButtonMultiSelector.prototype.onSelect = function () {
        var _this = this;
        if (this.loading || this.disabled)
            return;
        setTimeout(function () {
            if (_this.selectedItem) {
                var paramsEvent = { detail: _this.selectedItem, bubbles: true };
                var changeEvent = new CustomEvent("item-selected", paramsEvent);
                _this.element.dispatchEvent(changeEvent);
            }
        });
    };
    ButtonMultiSelector.prototype.getValue = function (item) {
        return this.selectedValuePath && item ? item[this.selectedValuePath] : item;
    };
    ButtonMultiSelector.prototype.attached = function () {
        this.subscriptionToDocumentClickEvent = this.eventAggrigator.subscribe(Messages.documentClick, this.closePopup);
        // disables TabIndex if Disabled
        if (this.disabled) {
            this.tab = -1;
        }
        this.dropdown = require("./button-multi-selector-dropdown.html").replace("<template>", "").replace("</template>", "");
    };
    Object.defineProperty(ButtonMultiSelector.prototype, "invertDropdown", {
        get: function () {
            if (this.dropdownDirection != 'auto')
                return this.dropdownDirection == 'up';
            if (!this.dropdownElement)
                return this._invertDropdown;
            var scrollViewer = this.getScrollParent(this.dropdownElement);
            if (scrollViewer) {
                if (!this.scrollViewerTop) {
                    this.scrollViewerTop = this.getTop(scrollViewer);
                }
                var dropdownPosition = ((this.getTop($(this.dropdownElement).parent().get(0)) + $(this.dropdownElement).parent().get(0).clientHeight) - this.scrollViewerTop) + this.dropdownElement.clientHeight;
                if (scrollViewer.nodeType != document.DOCUMENT_FRAGMENT_NODE && scrollViewer.clientHeight) {
                    this._invertDropdown = scrollViewer.clientHeight < dropdownPosition;
                }
            }
            return this._invertDropdown;
        },
        enumerable: false,
        configurable: true
    });
    ButtonMultiSelector.prototype.getTop = function (elem) {
        if (!elem || !elem.getBoundingClientRect) {
            return 0;
        }
        var rect = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var docElem = doc.documentElement;
        var win = doc.defaultView;
        return rect.top + win.pageYOffset - docElem.clientTop;
    };
    ButtonMultiSelector.prototype.getScrollParent = function (node) {
        if (node === null) {
            return null;
        }
        if (this.hasScroll(node)) {
            return node;
        }
        else {
            return this.getScrollParent(node.parentNode);
        }
    };
    ButtonMultiSelector.prototype.hasScroll = function (el) {
        if (el.nodeType != document.ELEMENT_NODE) {
            return true;
        }
        var $el = $(el), sY = $el.css("overflow-y"), hidden = "hidden", // minifiers would like this better
        visible = "visible", scroll = "scroll";
        if (sY === hidden || sY === visible) {
            return false;
        }
        if (sY === scroll) {
            return true;
        }
        // compare client and scroll dimensions to see if a scrollbar is needed
        return $el.innerHeight() < el.scrollHeight || // make use of potential short circuit
            $el.innerWidth() < el.scrollWidth;
    };
    ButtonMultiSelector.prototype.click = function (e) {
        if (this.isDropdownOpen) {
            this.closePopup();
            return;
        }
        if (this.loading || this.disabled)
            return;
        this.eventAggrigator.publish(Messages.documentClick, { source: "multi-button-selector" });
        e.stopPropagation();
        this.isDropdownOpen = !this.isDropdownOpen;
    };
    ButtonMultiSelector.prototype.disabledChanged = function () {
        if (this.disabled) {
            this.tab = -1;
        }
        else {
            this.tab = 0;
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ButtonMultiSelector.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ButtonMultiSelector.prototype, "type", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "loading", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "ripple", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ButtonMultiSelector.prototype, "tab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "showOnAdorner", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], ButtonMultiSelector.prototype, "selectedItem", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ButtonMultiSelector.prototype, "selectedValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ButtonMultiSelector.prototype, "selectedValuePath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "isDropdownOpen", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ButtonMultiSelector.prototype, "displayMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], ButtonMultiSelector.prototype, "itemSource", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "setDefault", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ButtonMultiSelector.prototype, "autoWidthDropdown", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ButtonMultiSelector.prototype, "dropdownDirection", void 0);
    ButtonMultiSelector = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, EventAggregator])
    ], ButtonMultiSelector);
    return ButtonMultiSelector;
}());
export { ButtonMultiSelector };
